import { Vector3, Quaternion } from 'three';

const _mid = new Vector3();
const _axis = new Vector3();
const _up = new Vector3(0, 1, 0);
const _quat = new Quaternion();

/** Pose a unit-height Y cylinder between two world-space points. */
export function poseCylinder(mesh, a, b, radius = 0.05) {
  _axis.copy(b).sub(a);
  const length = Math.max(0.0001, _axis.length());
  _axis.multiplyScalar(1 / length);
  _quat.setFromUnitVectors(_up, _axis);
  mesh.position.copy(_mid.copy(a).add(b).multiplyScalar(0.5));
  mesh.quaternion.copy(_quat);
  mesh.scale.set(radius, length, radius);
  mesh.updateMatrix();
}

/** Horizontal point around a centre, with an optional height. */
export function pointOnRing(out, centre, radius, angle, height = 0) {
  return out.set(
    centre.x + Math.cos(angle) * radius,
    centre.y + height,
    centre.z + Math.sin(angle) * radius
  );
}
